import React, { useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';
const Rotate = (props) => {
    const { children, disabled } = props;
    const rotateAnim = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        if (!disabled) {
            Animated
                .loop(Animated.sequence([
                Animated.timing(rotateAnim, {
                    toValue: 1,
                    duration: 1000,
                    useNativeDriver: false,
                    easing: Easing.linear,
                }),
            ]))
                .start(() => rotateAnim.setValue(0));
        }
        else {
            rotateAnim.stopAnimation();
        }
    }, [disabled]);
    const interpolateRotation = rotateAnim.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg'],
    });
    return (<Animated.View style={{ transform: [{ rotate: interpolateRotation }] }}>
      {children}
    </Animated.View>);
};
Rotate.displayName = 'Rotate';
export default Rotate;
//# sourceMappingURL=Rotate.js.map